<template>
  <div class="login-fade-background-wrapper">

    <div class="overlay"></div>

    <layout-background :image="backGround" ref="backGround" class="opacity-animation opacity-fill"/>
    <layout-background :image="foreGround" ref="foreGround" class="opacity-animation opacity-zero"/>

  </div>
</template>

<script>
import LayoutBackground from './LayoutBackground';

export default {
  name: 'ImageBackground',
  components: {
    LayoutBackground,
  },
  props: {
    duration: {
      type: Number,
      default: 500,
    },
    delay: {
      type: Number,
      default: 3000,
    },
    images: {
      type: Array,
    },
  },
  methods: {
    changeBackground() {
      const cssArray = ['opacity-fill', 'opacity-zero'];
      let backClass = null;
      let foreClass = null;
      const { length } = this.images;

      if (this.changeCount >= length) this.changeCount = 0;

      const backIndex = this.changeCount;
      const foreIndex = this.changeCount + 1 >= length ? 0 : this.changeCount + 1;

      if (this.changeCount % 2 === 0) {
        this.backGround = this.images[backIndex];
        this.foreGround = this.images[foreIndex];
        [backClass, foreClass] = cssArray;
      } else {
        this.backGround = this.images[foreIndex];
        this.foreGround = this.images[backIndex];
        [backClass, foreClass] = cssArray;
      }

      this.$refs.backGround.$el.classList.remove(backClass);
      this.$refs.foreGround.$el.classList.remove(foreClass);

      this.$refs.backGround.$el.classList.add(foreClass);
      this.$refs.foreGround.$el.classList.add(backClass);

      this.changeCount += 1;
    },
  },
  data() {
    return {
      foreGround: this.images.length > 1 ? this.images[1] : null,
      backGround: this.images.length === 0 ? null : this.images[0],
      intervalInstance: null,
      changeCount: 0,
    };
  },
  created() {
    const isChange = this.intervalInstance === null
      && this.background !== null
      && this.foreGround !== null;

    if (isChange === false) return;

    this.intervalInstance = setInterval(this.changeBackground, this.delay + this.duration);
  },
  destroyed() {
    clearInterval(this.intervalInstance);
  },
};
</script>

<style lang="scss" scoped>
.login-fade-background-wrapper {
  .overlay {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.6);
  }

  .opacity-animation {
    transition: opacity 0.5s ease-in-out;
  }

  .opacity-fill {
    opacity: 1.0;
  }

  .opacity-zero {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/login/layouts/ImageBackground.vue